import React, { Component } from 'react';
import Card from 'react-bootstrap/Card';
import { Link } from "react-router-dom";
import SupervisorSignoff from './SupervisorSignoff'
import { MyContext, MyGlobal, MyHeading, MyAlert } from '../GlobalContext';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ListGroup from 'react-bootstrap/ListGroup'
import Badge from 'react-bootstrap/Badge'
import * as MySound from '../MySound';

export class MXDockChooseShipment extends Component {
    static displayName = MXDockChooseShipment.name;
    constructor(props) {
        super(props);
        this.state = {
            alertMessage: "",
            shipments: [],
            filteredShipments: [],
            scannedShipmentRef: "",
            scannedshipmentError: "",
            loading: false
        };
        this.history = props.history;

    }
    componentDidMount() {
        this.getShipments();
    }
    goto(page, data) {
        this.history.push({
            pathname: page,
            state: data
        });
    }

    render() {
        var parent = this;
        const handleSearchInput = e => {
            var searchText = e.target.value;
            var filteredItems = this.state.shipments.filter(function (item) {
                return item.shipment_ref.toUpperCase().indexOf(searchText.toUpperCase()) > -1;
            });
            this.setState({ filteredShipments: filteredItems });
        };
        let alertMessage = this.state.alertMessage;
        alertMessage = alertMessage != "" ? <MyAlert variant="danger">{alertMessage}</MyAlert> : "";
        return (
            <>                       
                <MyHeading>Maersk Cross Dock</MyHeading>
                {alertMessage}     
                <h6>Chose Shipment</h6>
                {this.state.loading && <div className="p1"> <em>Loading ... </em></div>}
                {!this.state.loading && this.state.shipments.length === 0 && <div className="p1">There are no shipments!</div>}
                {this.state.shipments.length > 0 && <div>
                    <Row className="mt-1 mb-1">
                        <Col>
                            <input autoFocus="autofocus" className="filter form-control" type="text" placeholder="Scan shipment reference..."
                                onInput={handleSearchInput}
                                value={this.state.scannedShipmentRef}
                                //ref="ssccCartonBarcodeInput"
                                onKeyPress={(e) => {
                                    if (e.keyCode === 13 || e.charCode === 13 || e.which === 13) {
                                        this.findShipment();
                                    }
                                }}
                                onChange={(e) => {
                                    this.setState({ scannedShipmentRef: e.target.value, scannedshipmentError:"" });
                                }} />
                        </Col>
                    </Row>
                    {this.state.scannedshipmentError.length > 0 && <div class="p1 text-danger"> Invalid scan!</div>}
                    {this.state.filteredShipments.map(function (item) {
                        var child = parent;
                        return (
                            <Card className="mb-1" key={item.shipment_ref}>
                                <Card.Header>
                                    {item.group} - {item.shipment_ref}
                                </Card.Header  >
                                <Card.Body>
                                    <Card.Text>
                                        <span><b>POs:</b> {item.stores}</span><br />
                                        <span><b>Devanned Cartons:</b> {item.receipted_cartons}</span><br />
                                        <span><b>Total Cartons:</b> {item.total_cartons}</span><br />
                                        <Button type="button" className="btn btn-success col-12 mb-2 mt-1" onClick={() => { child.devanShipment(item) }}>Devan</Button>
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        );
                    })}
                </div>}

            </>
        );
    }

    devanShipment(shipment) {
        this.setState({ loading: true });
        const submitRequest = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(shipment)
        };
        fetch('api/MXDock/ValidateShipmentOrderLocations', submitRequest)
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const result = isJson ? await response.json() : null;
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    var errorDetail = JSON.parse(errorText);
                    var error = JSON.stringify(errorDetail.errors);
                    this.setState({ alertMessage: error, loading: false });
                }
                else {
                    if (result.success) {
                        this.setState({ loading: false, alertMessage: "", });
                        this.goto('ScanCarton', { selectedShipment: shipment });
                    }
                    else {
                        this.goto('AssignLocations', { selectedShipment: shipment });
                    }
                }
            })
            .catch(error => {
                this.setState({ alertMessage: error });
            });
    }

    async getShipments() {
        this.setState({ loading: true });
        fetch(`api/MXDock/GetShipmentDetails`)
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const result = isJson ? await response.json() : null;
                
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    var errorDetail = JSON.parse(errorText);
                    var error = JSON.stringify(errorDetail.errors);
                    this.setState({ alertMessage: error, loading: false });
                }
                else {
                    if (result.success) {
                        this.setState({ loading: false, alertMessage: "", shipments: result.data, filteredShipments: result.data });
                    }
                    else {
                        this.setState({ loading: false, alertMessage: result.errorMessage });
                    }
                }
            })
            .catch(error => {
                this.setState({ alertMessage: error });
            });
    }

    findShipment() {
        var selectedShipment = null;
        var scannedText = this.state.scannedShipmentRef;
        var filteredItems = this.state.shipments.filter(function (item) {
            if (item.shipment_ref.trim().toUpperCase() === scannedText.trim().toUpperCase()) {
                selectedShipment = item;
            }
        });
        if (selectedShipment !== null) {
            this.devanShipment(selectedShipment);
        }
        else {
            this.setState({ scannedshipmentError: "Invalid Scan!" });
            MySound.play(MySound.Sound.stop);
        }
    }
}
export default MXDockChooseShipment;